/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Filmstrip_Frame_CountInputs */



/**
* | output |
* | --- |
* | "Film Strip Frames" |
*
* @param {Options_Editor_Filmstrip_Frame_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_filmstrip_frame_count = /** @type {((inputs?: Options_Editor_Filmstrip_Frame_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Filmstrip_Frame_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cadres de pellicule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filmstreifenbilder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fotogrammi della striscia di pellicola")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кадры кинопленки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fotogramas de tira de película")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("胶片帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルムストリップのフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिल्म स्ट्रिप फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fotogramas de tira de filme")
	return /** @type {LocalizedString} */ ("Film Strip Frames")
});